/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Practicalexperience_Placeholder1Inputs */

const en_job_form_practicalexperience_placeholder1 = /** @type {(inputs: Job_Form_Practicalexperience_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required or desired practical experience...`)
};

const de_job_form_practicalexperience_placeholder1 = /** @type {(inputs: Job_Form_Practicalexperience_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderliche oder gewünschte Praxiserfahrung…`)
};

/**
* | output |
* | --- |
* | "Required or desired practical experience..." |
*
* @param {Job_Form_Practicalexperience_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_practicalexperience_placeholder1 = /** @type {((inputs?: Job_Form_Practicalexperience_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Practicalexperience_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_practicalexperience_placeholder1(inputs)
	return en_job_form_practicalexperience_placeholder1(inputs)
});
export { job_form_practicalexperience_placeholder1 as "job_form_practicalExperience_placeholder" }